export default "__VITE_ASSET__Czo3v19S__ 400w, __VITE_ASSET__C4_Qxsdp__ 800w, __VITE_ASSET__csC4Mvs8__ 1200w";